<template>
  <div id="email-action-buttons" class="flex-row align-items-center gap-sm">
    <div v-if="!row.sent">
      <dd-icon-button
        v-if="row.processed === 0"
        id="action-button-process"
        icon="mdi mdi-check"
        title="Verwerken"
        size="xl"
        class="actions-button"
        @click="processEmail(row)"
      />
      <dd-icon-button
        v-else
        id="action-button-unprocess"
        icon="mdi mdi-undo"
        title="Markeren als onverwerkt"
        size="xl"
        class="actions-button"
        @click="unprocessEmail(row)"
      />
    </div>
    <div>
      <dd-icon-button
        v-if="!row.customer_id"
        id="action-button-match"
        icon="mdi mdi-link-variant"
        title="Koppelen"
        size="xl"
        class="actions-button"
        @click="showMatchModal(row)"
      />
      <dd-icon-button
        v-else
        id="action-button-unmatch"
        icon="mdi mdi-link-variant-off"
        title="Ontkoppelen"
        size="xl"
        class="actions-button"
        type="danger"
        @click="unmatchEmail(row)"
      />
    </div>
  </div>
</template>

<script>
import EmailApi from '~/api/email.js'
import accountStateEnum from "../../enums/AccountStateEnum";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CompactListActions.vue",
  computed: {
    ...mapGetters('email', [
       'accountState'
    ]),
    accountStateEnum() {
      return accountStateEnum;
    }
  },
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  methods:{
    ...mapActions('email', [
      "loadEmails",
      "loadUnprocessedEmailCount",
      "setSendState",
      "setMatchState",
      "showReplyOrForwardEmail",
      "showMatchEmail"
    ]),
    async processEmail(e){
      this.row.processed = 1;
      await EmailApi.processEmail(e.id);
      this.loadUnprocessedEmailCount();
      this.loadEmails();
    },
    async unprocessEmail(e){
      this.row.processed = 0;
      await EmailApi.unprocessEmail(e.id);
      this.loadUnprocessedEmailCount();
      this.loadEmails();
    },
    async showMatchModal(e){
      await this.showMatchEmail([e.id]);
    },
    async unmatchEmail(e){
      this.row.customerId = undefined;
      await EmailApi.unmatchEmail(e.id);
      await this.loadEmails();
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/_default.scss";
.actions-button{
  min-height: $spacing-lg !important;
  padding: 0;
}
</style>
